export default __webpack_public_path__ + "static/media/star.dffde562.svg";